<template>
    <div id="maincontent">
    <div class="d-flex flex-row " id="main">
    <div class="d-flex flex-column justify-content-between " id="steps">
        <div class="row justify-content-around">
            <div class="col text-right step-title">
                <p>Personal Info</p>
                <!-- <p class="bottom-text" style="color: transparent;">Personal Info</p> -->
            </div>
            <div class="col steps-step circle-top">
                <div class="circle done"><div class="checkmark"></div></div>
            </div>
        </div>
        <div class="row justify-content-around">
            <div class="col text-right step-title">
                <p>Company</p>
                <!-- <p class="bottom-text">Brief company info</p> -->
            </div>
            <div class="col steps-step grey-circle">
                <div class="circle done"><div class="checkmark"></div></div>
            </div>
        </div>
        <div class="row justify-content-around">
            <div class="col text-right step-title">
                <p>Your message</p>
                <!-- <p class="bottom-text">Company Description</p> -->
            </div>
            <div class="col steps-step grey-circle">
                    <div class="circle active circle-last">3</div>
            </div>
        </div>
    </div>
        <div id="regform">
            <form class="text-left">
                <!-- <p id="titlename">Company</p> -->
                <div class="group">
                    <textarea v-model="message" @input="messagechange" :class="{used: messageused}" rows="10" class="textarea"/>
                    <span class="highlight"></span>
                    <span class="bar"></span>
                    <label>Please write a short message that profile visitors will see.</label>
                </div>
            </form>
            <p v-if="feedback" class="feedback">{{feedback}}</p>
            <div class="form-inline buttons justify-content-center" v-if="!registerEnd">
                <a href="#" class="button" @click.prevent="prev">Prev</a>
                <span>|</span>
                <a href="#" @click.prevent="apply" id="apply">Apply</a>
            </div>
        </div>
        <img ref="test"/>
        <!-- <div class="col">
            <div class="card shadow">
            <div class="card-header d-flex flex-row justify-content-around">
                <img class="avatar rounded-circle" ref="Iconref" src=""/>
                <img class="companyLogo" ref="Logoref" src=""/>
            </div>
            <div class="card-body">
                <p class="name">{{ previousname }}</p>
                <div class="infoitem">
                    <span><img class="icon" src="../../assets/icons8-organization-50.png"/></span>
                    <span>{{previouscompanyName}}</span>
                </div>
                <div class="infoitem">
                    <span><img class="icon" src="../../assets/icons8-prize-50.png"/></span>
                    <span>{{previousrole}}</span>
                </div>
                <div class="infoitem">
                    <span><img class="icon" src="../../assets/icons8-envelope-50.png"/></span>
                    <span>{{previousemail}}</span>
                </div>
            </div>
            <div class="card-footer">
                {{previousarea}}
            </div>
        </div>
        </div> -->
    </div>
    
    <div v-if="registerEnd" class="form-inline buttons justify-content-end">
        <p>Applying...</p>
    </div>
    </div>
</template>
<script>
import firebase from '@/firebase/init'
import Compressor from 'image-compressor.js'
export default {
    name: 'Step3',
    props:['uid', 'previousfirstname', 'previouslastname', 'previousemail', 'previouscity', 'previousrole', 'previousstate', 'previousspiritanimal', 'previousicon', 'previouscompanyName', 'previousbriefdescription', 'previouslogo', 'previousdescription', 'previousmessage'],
    data(){
        return{
            message: null,
            feedback: null,
            messageused: false,
            windowWidth: 0,
            registerEnd: false
        }
    },
    methods:{
        prev(){
            this.$router.push({name: 'Step2', params: {uid: this.uid, previousfirstname: this.previousfirstname, previouslastname: this.previouslastname, previousemail: this.previousemail, previouscity: this.previouscity, previousstate: this.previousstate, previousrole: this.previousrole, 
            previousspiritanimal: this.previousspiritanimal, previousicon: this.previousicon, previouscompanyName: this.previouscompanyName, previousbriefdescription: this.previousbriefdescription, previouslogo: this.previouslogo, previousdescription: this.previousdescription, previousmessage: this.message}})
        },
        apply(){
            this.registerEnd = true
            if(this.message){
                var thisObj = this;
                var db = firebase.firestore()
                var storageRef = firebase.storage().ref()
                var token = this.generate_token(32)
                var urlToSendIcon = ''
                var urlToSendLogo = ''
                var approveToken = this.generate_token(32)
                var declineToken = this.generate_token(32)
                var user_id;
                let ref = db.collection('users').where('UID', '==', this.uid)
                ref.get().then(snapshot=>{
                    snapshot.forEach(doc=>{
                        user_id = doc.id
                        db.collection("users").doc(doc.id).set({
                            ApproveToken: approveToken,
                            Approved: false,
                            BriefDescription: this.previousbriefdescription,
                            City: this.previouscity,
                            CompanyName: this.previouscompanyName,
                            CreateDate: new Date(),
                            DeclineToken: declineToken,
                            Description: this.previousdescription,
                            Email: this.previousemail,
                            Icon: 'images/users/icons/' + token + this.previousicon.name,
                            Logo: 'images/users/logos/' + token + this.previouslogo.name,
                            FirstName: this.previousfirstname,
                            LastName: this.previouslastname,
                            Message: this.message,
                            OnBoardingCompleted: true,
                            Role: this.previousrole,
                            SpiritAnimal: this.previousspiritanimal,
                            State: this.previousstate,
                            UID: this.uid
                        }).then(()=>{
                            var user = firebase.auth().currentUser
                                user.updateProfile({
                                displayName: this.previousfirstname
                                }).catch(function(error) {
                                    console.log(error)
                                })
                                var compressorIcon = new Compressor(this.previousicon, {
                                    quality: .5,
                                    success(result){
                                        var iconRef = storageRef.child('images/users/icons/' + token + thisObj.previousicon.name);
                                        iconRef.put(result)
                                        .then(()=>{
                                            iconRef.getDownloadURL().then(function(url) {
                                                urlToSendIcon = url

                                                var compressorLogo = new Compressor(thisObj.previouslogo, {
                                                quality: .5,
                                                success(result){
                                                        var logoRef = storageRef.child('images/users/logos/' + token + thisObj.previouslogo.name)
                                                        logoRef.put(result)
                                                        .then(()=>{
                                                            logoRef.getDownloadURL().then(function(url){
                                                                urlToSendLogo = url

                                                                db.collection("users").doc(doc.id).get().then(function(doc){
                                                                var userToSend = doc.data()
                                                                userToSend.id = doc.id
                                                                userToSend.Icon = urlToSendIcon
                                                                userToSend.Logo = urlToSendLogo
                                                                let sendMail = firebase.functions().httpsCallable('sendAdminMail')
                                                                sendMail({approveToken : approveToken, declineToken: declineToken, user: userToSend})
                                                                thisObj.$router.push({name: 'Home'})
                                                                })
                                                            })
                                                            .catch(function(error) {
                                                                console.log(error)
                                                                urlToSendLogo = ''
                                                                db.collection("users").doc(doc.id).get().then(function(doc){
                                                                var userToSend = doc.data()
                                                                userToSend.id = doc.id
                                                                userToSend.Icon = urlToSendIcon
                                                                userToSend.Logo = urlToSendLogo
                                                                let sendMail = firebase.functions().httpsCallable('sendAdminMail')
                                                                sendMail({approveToken : approveToken, declineToken: declineToken, user: userToSend})
                                                                thisObj.$router.push({name: 'Home'})
                                                                })
                                                            })
                                                        })
                                                        .catch(err=>{console.log(err)})
                                                },
                                                error(e){ console.log(e)}
                                            })  
                                            }).catch(function(error) {
                                                console.log(error)
                                                urlToSendIcon = ''
                                                db.collection("users").doc(doc.id).get().then(function(doc){
                                                var userToSend = doc.data()
                                                userToSend.id = doc.id
                                                userToSend.Icon = urlToSendIcon
                                                userToSend.Logo = urlToSendLogo
                                                let sendMail = firebase.functions().httpsCallable('sendAdminMail')
                                                sendMail({approveToken : approveToken, declineToken: declineToken, user: userToSend})
                                                thisObj.$router.push({name: 'Home'})
                                                })
                                            }) 
                                        })
                                        .catch(err=>{
                                            console.log(err);
                                        })
                                    },
                                    error(e){ console.log(e)}
                                })
                                
                        })
                    })
                })
                
            }
            else{
                this.feedback = "You must enter message"
            }
        },
        messagechange(e){
            this.message = e.target.value
            if(this.message == null || this.message == ''){this.messageused = false}
            else {this.messageused = true}
        },
        generate_token(length){
            //edit the token allowed characters
            var a = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890".split("");
            var b = [];  
            for (var i=0; i<length; i++) {
                var j = (Math.random() * (a.length-1)).toFixed(0);
                b[i] = a[j];
            }
            return b.join("");
        }
    },
    beforeCreate: function() {
            document.body.className = 'registration';
    },
    created(){
        if(this.previousmessage != null && this.previousmessage != ''){
            this.message = this.previousmessage
            this.messageused = true
        }
        if(!this.uid){
            this.$router.push({name: 'Step1'})
        }
        // var thisobj = this
        // var readerIcon  = new FileReader()
        // readerIcon.onloadend = function () {
        //     let res = readerIcon.result
        //     callbackIcon(res)
        // }

        // if (this.previousicon) {
        //     readerIcon.readAsDataURL(this.previousicon)
        // } else {
        //     thisobj.$refs.Iconref.src = ""
        // }
        // function callbackIcon(data){
        //     thisobj.$refs.Iconref.src  = data
        // }

        // var readerLogo  = new FileReader()

        // readerLogo.onloadend = function () {
        //     let res = readerLogo.result
        //     callbackLogo(res)
        // }
        // if (this.previouslogo) {
        //     readerLogo.readAsDataURL(this.previouslogo)
        // } else {
        //     thisobj.$refs.Logoref.src = ""
        // } 
        // function callbackLogo(data){
        //     thisobj.$refs.Logoref.src = data
        // }
    },
    mounted(){
    // window.addEventListener('resize', () => {
    //     this.windowWidth= window.innerWidth
    //   });
    }
}
</script>
<style scoped>
.feedback{
    color: red;
}
#titlename{
    color: #8954BA;
    font-size: 18px;
    font-family: Arial, Helvetica, sans-serif;
    margin-bottom: 2em;
}
#maincontent{
    height: 70%;
}
#main{
    /* height: 60%; */
    width: 90%;
    /* margin-bottom: 2em; */
}
#fileinput{
  margin-top: 2.5em;
}
#regform{
    margin-left: auto;
    margin-right: auto;
}
#titlename{
    color: #8954BA;
    font-size: 18px;
    font-family: Arial, Helvetica, sans-serif;
    margin-bottom: 2em;
}
#steps{
    width: 19em;
    padding-top: 3em;
    padding-bottom: 3em;
    height: 20em;
}
#steps p{
    margin: 0;
    display: inline-block;
    margin-bottom: 2em;
}
.step-title p{
    color: #686868;
    font-family: Arial, Helvetica, sans-serif;
    font-size: 14px;
}
.step-title .bottom-text{
    color: #A1A1A1;
}
.button{
    background-color: #5D38DB;
    border-color: white;
    padding: 1.2em 3.2em;
    border-radius: 7px;
    font-family: GothamBook;
    font-size: 13px;
    color: white;
    cursor: pointer !important;
    font-weight: bold;
    margin-right: 1em;
}
.form-inline span{
    color: #C9C9C9;
    font-size: 1.7em;
}
.textarea{
    border: none;
    border-radius: 0;
    border-bottom: 1.7px solid #D0D6E6;
    background-color: white;
    resize: none;
}
.circle{
  width: 2em;
  height: 2em;
  text-align: center;
  line-height: 2em;
  border-radius: 1em;
  background: white;
  border: 1px solid #5D38DB;
  color: black !important;
  margin: 0 1em;
  display: inline-block;
  color: white;
  position: relative;
}
.circle::before{
    margin-left: 3px;
    top: 2em;
    bottom: 0;
    position: absolute;
    content: "";
    width: 2px;
    height: 300%;
    background-color: #D9DCE6;
}
.circle-last::before{
    height: 200%;
}
.steps-step.circle-top::before{
    margin-left: 1.9em;
    bottom: 3em;
    position: absolute;
    content: "";
    width: 2px;
    height: 100%;
    background-color: #D9DCE6;
}
.steps-step.grey-circle::before{
    margin-left: 1.7em;
    bottom: 4.7em;
    position: absolute;
    content: "";
    width: 8px;
    height: 8px;
    border-radius: 1em;
    background-color: #D9DCE6;
}
.steps-step .active{
      background: #5D38DB;
      color: white !important;
}

.steps-step .done{
   border: 1px solid #78CA3C ;
}
.steps-step .done::before{
    margin-left: 4px;
}
.group{ 
  position:relative; 
  margin-bottom:45px; 
}
.textarea{
  font-size:18px;
  padding:10px 10px 10px 5px;
  display:block;
  width:600px;
  border:none;
  border-bottom:1px solid #D0D6E6;
  white-space: pre-wrap;
}
.textarea:focus{ outline:none; }

label{
  color:#686868;
  font-weight:normal;
  position:absolute;
  pointer-events:none;
  left:5px;
  top:10px;
  transition:0.2s ease all;
  font-family: GothamBook;
  font-size: 14px;
}


.used ~label     {
  top:-30px;
  font-size:14px;
  transition: 0.2s ease all;
  color:#686868;
}
.used{
    color: #8954BA;
    font-family: Arial, Helvetica, sans-serif;
    font-size: 14px;
}
.bar  { position:relative; display:block; width:600px; }
.bar:before, .bar:after   {
  content:'';
  height:2px; 
  width:0;
  bottom:1px; 
  position:absolute;
  background:#8954BA; 
  transition:0.2s ease all; 
}
.bar:before {
  left:50%;
}
.bar:after {
  right:50%; 
}

.textarea:focus ~ .bar:before, .textarea:focus ~ .bar:after {
  width:50%;
}
.highlight {
  position:absolute;
  height:60%; 
  width:100px; 
  top:25%; 
  left:0;
  pointer-events:none;
  opacity:0.5;
}

.textarea:focus ~ .highlight {
  animation:inputHighlighter 0.3s ease;
}

@keyframes inputHighlighter {
  from  { background:#5264AE; }
  to    { width:0; background:transparent; }
}

.avatar{
    height: 5em;
    transform: translateY(35%);
}
.companyLogo{
    height: 5em;
}
.name{
    font-size: 1.3em;
    font-weight: bold;
    color: black;
    margin-bottom: 0;
}
.card{
    width: 20em;
}
.card-body{
    padding-left: 1em;
}
.card-footer{
    color: #9665c1;
    font-size: 0.8em;
    font-weight: bold;
    text-align: left;
    padding-left: 1em;
    background-color: white;
    border-radius: 0px 0px 10px 10px !important;
}
.card-body span{
    font-size: 0.8em;
    font-weight: 500;
    color: #909090;
}
.card-body div, .card-body p{
    text-align: left;
}
.card-header{
    padding-top: 2em;
    background-color: white;
    border-radius: 10px 10px 0px 0px !important;
}
.card{
    border-radius: 10px 10px 10px 10px !important;
    border: none;
    margin-top: 1em;
    margin-left: 3em;
}
.icon{
    height: 18px;
    margin-right: 1em;
}
#apply{
    margin-left: 1em;
    background-color: #5D38DB;
    border-color: white;
    padding: 1.2em 3em;
    border-radius: 7px;
    font-family: GothamBook;
    font-size: 13px;
    color: white;
    font-weight: bold;
    cursor: pointer !important;
}
.buttons{
    margin-top: 2em;
}
@media (max-width: 1124px) {
    #steps{
        display: none !important;
    }
}

@media (max-width: 550px) {
    #main{
        margin-top: 3em;
    }
    .group{
        margin-left: 1em;
    }
    #steps{
        display: none;
    }
    
    .graphic{
        display: none;
    }
    .card{
        margin-left: 0;
    }
}
@media (max-width: 1000px) {
    .textarea{
        width: 400px;
    }
    .bar{
        width: 400px;
    }
}
@media (max-width: 800px) {
    .textarea{
        width: 310px;
    }
    .bar{
        width: 310px;
    }
}
@media (min-width: 1713px){
    .steps-step.grey-circle::before{
        bottom: 4.5em;
    }
    .steps-step.circle-top::before{
        bottom: 2em;
    } 
}
.checkmark{
  display:inline-block;
  }
  .checkmark::after{
    content: '';
    display: block;
    width: 9px;
    height: 18px;
    border: solid #78CA3C;
    border-width: 0 2px 2px 0;
    transform: rotate(45deg);
    margin-left: 0.1em;
  }
</style>



// WEBPACK FOOTER //
// src/components/steps/Step3.vue